import { SpareminJwtIssuer, SpareminJwtRole } from './types';

export const SPAREMIN_JWT_ISSUER: SpareminJwtIssuer = 'sparemin.com';
export const SPAREMIN_JWT_ROLES: SpareminJwtRole[] = [
  'unverified-user',
  'verified-user',
];
